var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { firstRight } from "./../ricos-content";
import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1";
import {
  getUnsupportedFromTiptap,
  getUnsupportedToTiptap,
  nodeConverters
} from "./node-converters";
const convertTimestamp = (timestamp) => firstRight(timestamp, "", [
  [(t) => typeof t === "string", (t) => t],
  [(t) => typeof (t == null ? void 0 : t.toISOString) === "function", (t) => t.toISOString()]
]);
const convertMetadata = (metadata) => __spreadProps(__spreadValues({}, metadata), {
  createdTimestamp: convertTimestamp(metadata.createdTimestamp),
  updatedTimestamp: convertTimestamp(metadata.updatedTimestamp)
});
const normalizeTimestamps = (metadata) => {
  const { createdTimestamp, updatedTimestamp } = metadata != null ? metadata : {};
  return __spreadValues(__spreadValues({
    version: metadata == null ? void 0 : metadata.version,
    id: metadata == null ? void 0 : metadata.id
  }, createdTimestamp ? { createdTimestamp } : {}), updatedTimestamp ? { updatedTimestamp } : {});
};
const FROM_TIPTAP_BY_TYPE = Object.fromEntries(
  [...nodeConverters].reverse().flatMap((converter) => converter.fromTiptap.types.map((type) => [type, converter.fromTiptap]))
);
const getFromTiptapConverter = (node) => FROM_TIPTAP_BY_TYPE[node.type] || getUnsupportedFromTiptap(node);
const fromTiptapNode = (node) => getFromTiptapConverter(node).convert(node, fromTipTapToNodes);
function fromTipTapToNodes(node) {
  return (node.content || []).map(fromTiptapNode);
}
const fromTiptap = (content) => {
  var _a, _b;
  return {
    documentStyle: (_a = content.attrs) == null ? void 0 : _a.documentStyle,
    metadata: normalizeTimestamps((_b = content.attrs) == null ? void 0 : _b.metadata),
    nodes: fromTipTapToNodes(content)
  };
};
const tiptapNodeVisitor = fromTipTapToNodes;
const TO_TIPTAP_BY_TYPE = Object.fromEntries(
  [...nodeConverters].reverse().flatMap((converter) => converter.toTiptap.types.map((type) => [type, converter.toTiptap]))
);
const getToTiptapConverter = (node) => TO_TIPTAP_BY_TYPE[node.type] || getUnsupportedToTiptap(node);
const toTiptapNode = (node) => getToTiptapConverter(node).convert(node, fromRicosToTiptapNodes);
function fromRicosToTiptapNodes(node) {
  return (node.nodes || []).map(toTiptapNode);
}
const toTiptapNodeAttrs = (node) => toTiptapNode(node).attrs;
const toTiptap = (content) => {
  const ricosRoot = { id: "root", type: Node_Type.UNRECOGNIZED, nodes: content.nodes };
  return {
    type: "doc",
    content: fromRicosToTiptapNodes(ricosRoot),
    attrs: {
      metadata: convertMetadata(content.metadata || { version: 1 }),
      documentStyle: content.documentStyle || {}
    }
  };
};
const ricosNodeVisitor = fromRicosToTiptapNodes;
export {
  fromTiptap,
  fromTiptapNode,
  ricosNodeVisitor,
  tiptapNodeVisitor,
  toTiptap,
  toTiptapNode,
  toTiptapNodeAttrs
};
//# sourceMappingURL=tiptap-converters.js.map
